var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"imgContainer white--text pa-0",style:(_vm.setStyle),attrs:{"cols":"12"}},[_c('section-title',{staticClass:"title",attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"fontSize":_vm.fontSize}}),_c('div',{attrs:{"height":"100%"}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }